// /routes/AssessmentRoute.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { decodeId } from "../utills/idUtils";
import { getAsmtById, getUserByUserId } from "./authService";
import { fetchUserData2, useAuth } from "../context/AuthContext";
import axios from "axios";

const AssessmentRoute = ({ children }) => {

    const API_URL = process.env.REACT_APP_API_URL;

    const { encodedId } = useParams();
    const navigate = useNavigate();
    const { state, dispatch } = useAuth();
    const user = state?.user;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            try {
                console.log("AssessmentRoute: encodedId from params:", encodedId);
                const assessmentId = decodeId(encodedId);
                console.log("AssessmentRoute: Decoded assessmentId:", assessmentId);
                // console.log("response==>", response)
                const assessment = await getAsmtById(assessmentId);
                console.log("AssessmentRoute: assessment fetched:", assessment);

                const assessmentUserId = assessment?.created_by_user;
                console.log("AssessmentRoute: assessmentUserId:", assessmentUserId);
                console.log("AssessmentRoute: current user:", user);

                if (user?.user_id !== assessmentUserId) {
                    const adminToken = localStorage.getItem('adminToken') || localStorage.getItem('authToken');
                    if (adminToken) {
                        console.log("AssessmentRoute: user_id mismatch but adminUsrtoken found, calling fetchUserData2 and allowing access");

                        try {
                            // First, call the admin-users API to get the admin token
                            console.log(`AssessmentRoute: Fetching admin user for userId: ${assessmentUserId}`);
                            const response = await axios.get(`${API_URL}/admin-users/${assessmentUserId}`);
                            const { user: adminUser, adminUsrtoken } = response.data;
                            if (adminUsrtoken) {
                                localStorage.setItem('adminUsrtoken', adminUsrtoken);
                                console.log("AssessmentRoute: adminUsrtoken set in localStorage", adminUsrtoken);
                                await fetchUserData2(adminUsrtoken, dispatch);
                                // Optionally, you can also set admin user in context if needed
                            } else {
                                console.warn("AssessmentRoute: No adminUsrtoken received from /admin-users API");
                                navigate("/login");
                                // return;
                            }
                        } catch (err) {
                            console.error("AssessmentRoute: Error fetching admin user or setting token", err);
                            navigate("/login");
                            // return;
                        }
                    }
                    else {
                        console.log("AssessmentRoute: user_id mismatch and no adminUsrtoken, redirecting to /login");
                        navigate("/login");
                    }
                }
                setLoading(false);
                console.log("AssessmentRoute: loading set to false");
            } catch (error) {
                console.error("AssessmentRoute Error:", error);
                // navigate("/error");
            }
        };

        init();
    }, [encodedId, user, navigate]);

    if (loading) {
        console.log("AssessmentRoute: loading, rendering Loader");
        return (
            <div className="w-full h-screen flex items-center justify-center">
                {/* <Loader /> */}
                loading...
            </div>
        );
    }

    console.log("AssessmentRoute: rendering children");
    return <>{children}</>;
};

export default AssessmentRoute;
